/**
 * Lander Form — Multi-step lead capture form (vanilla JS).
 *
 * Handles step navigation, progress bar, field validation,
 * phone masking, zip-to-city/state lookup, and AJAX submission.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  /* ---------------------------------------------------------------
   * INIT
   * ------------------------------------------------------------- */
  function init() {
    var form = document.getElementById('landerLeadForm');
    if (!form) return;

    var steps      = Array.prototype.slice.call(form.querySelectorAll('.lander-step'));
    var totalSteps = steps.length;
    var currentIdx = 0;

    // Icon-choice items (Yes/No buttons)
    var choiceItems = form.querySelectorAll('.lander-choice-item');
    choiceItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var hidden = this.closest('.lander-icon-container').querySelector('input[type="hidden"]');
        if (hidden) hidden.value = this.getAttribute('data-value');
        goToStep(currentIdx + 1);
      });
    });

    // Continue buttons
    var continueButtons = form.querySelectorAll('.lander-continue');
    continueButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var validationType = this.getAttribute('data-validate');

        if (validationType === 'contact') {
          if (validateContact()) {
            submitForm();
          }
          return;
        }

        if (validationType && !validateStep(validationType)) return;

        if (validationType === 'zip') {
          zipGetCityState(function () {
            goToStep(currentIdx + 1);
          });
          return;
        }

        goToStep(currentIdx + 1);
      });
    });

    // Phone mask
    var phoneInput = document.getElementById('lander_phone');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var digits = this.value.replace(/\D/g, '').substring(0, 10);
        var formatted = '';
        if (digits.length > 6) {
          formatted = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
        } else if (digits.length > 3) {
          formatted = '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
        } else if (digits.length > 0) {
          formatted = '(' + digits;
        }
        this.value = formatted;
      });
    }

    // Clear errors on input
    form.querySelectorAll('input, textarea, select').forEach(function (el) {
      el.addEventListener('input', function () {
        var errEl = this.parentElement.querySelector('.lander-error');
        if (errEl) errEl.textContent = '';
      });
    });

    // Enter key — trigger active step's continue button
    form.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var activeStep = steps[currentIdx];
        var btn = activeStep.querySelector('.lander-continue');
        if (btn) btn.click();
      }
    });

    /* ---------------------------------------------------------------
     * STEP NAVIGATION
     * ------------------------------------------------------------- */
    function goToStep(idx) {
      if (idx < 0 || idx >= totalSteps) return;
      steps[currentIdx].classList.remove('active');
      currentIdx = idx;
      steps[currentIdx].classList.add('active');
      updateProgressBar();
      scrollToForm();
    }

    function updateProgressBar() {
      var percent;
      if (currentIdx === 0) {
        percent = 10;
      } else if (currentIdx === totalSteps - 1) {
        percent = 97;
      } else {
        percent = Math.round((currentIdx / (totalSteps - 1)) * 100);
      }
      var pgLine = document.getElementById('pgLine');
      var pgPercent = document.getElementById('pgLinePercent');
      if (pgLine) pgLine.style.width = percent + '%';
      if (pgPercent) pgPercent.textContent = percent;
    }

    function scrollToForm() {
      var wrapper = form.closest('.lander-form-wrapper');
      if (wrapper) {
        var offset = wrapper.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }

    /* ---------------------------------------------------------------
     * VALIDATION
     * ------------------------------------------------------------- */
    function validateStep(type) {
      switch (type) {
        case 'select': return validateSelect();
        case 'zip':    return validateZip();
        case 'details': return validateDetails();
        case 'name':   return validateName();
        case 'contact': return validateContact();
        default: return true;
      }
    }

    function validateSelect() {
      var sel = document.getElementById('injury_cause');
      return sel && sel.selectedIndex > 0;
    }

    function validateZip() {
      var zip = document.getElementById('user_zip').value.trim();
      var err = document.getElementById('userZipError');
      if (!/^\d{5}$/.test(zip)) {
        err.textContent = '* Please enter a valid zip code';
        return false;
      }
      err.textContent = '';
      return true;
    }

    function validateDetails() {
      var val = document.getElementById('case_details').value.trim();
      var err = document.getElementById('caseDetailsError');
      if (val.length < 3) {
        err.textContent = '* Please describe your accident. Or call now.';
        return false;
      }
      err.textContent = '';
      return true;
    }

    function validateName() {
      var valid = true;
      var nameFilter = /^[\w'\-,.][^0-9_!¡?¿÷/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$/;

      var fname = document.getElementById('first_name').value.trim();
      var fnameErr = document.getElementById('firstNameError');
      if (!nameFilter.test(fname)) {
        fnameErr.textContent = '* Please enter your first name';
        valid = false;
      } else {
        fnameErr.textContent = '';
      }

      var lname = document.getElementById('last_name').value.trim();
      var lnameErr = document.getElementById('lastNameError');
      var blockedNames = ['doe','cena','mouse','trump','no','asdf','nunya','business','smoe','schmo','schmoe','name'];
      if (!nameFilter.test(lname) || blockedNames.indexOf(lname.toLowerCase()) !== -1) {
        lnameErr.textContent = '* Please enter your last name';
        valid = false;
      } else {
        lnameErr.textContent = '';
      }

      return valid;
    }

    function validateContact() {
      var valid = true;

      // Email
      var email = document.getElementById('lander_email').value.trim();
      var emailErr = document.getElementById('emailError');
      var emailFilter = /^([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@(([0-9a-zA-Z])+([-\w]*[0-9a-zA-Z])*\.)+[a-zA-Z]{2,9})$/;
      if (!emailFilter.test(email) || email.toLowerCase().indexOf('spam') > -1 || email.toLowerCase().indexOf('nunya') > -1) {
        emailErr.textContent = '* Please enter a valid email address.';
        valid = false;
      } else {
        emailErr.textContent = '';
      }

      // Phone
      var phoneRaw = document.getElementById('lander_phone').value.trim();
      var phoneErr = document.getElementById('phoneError');
      var phoneFilter = /^(?:\([2-9]\d{2}\) ?|[2-9]\d{2}(?:-? ?))[2-9]\d{2}[- ]?\d{4}$/;
      var digits = phoneRaw.replace(/\D/g, '');
      var areaCode = digits.substring(0, 3);
      var exchange = digits.substring(3, 6);
      var last4 = digits.substring(6, 10);
      var tollFree = ['800','888','877','866','855','844','833'];

      if (
        !phoneFilter.test(phoneRaw) ||
        tollFree.indexOf(areaCode) !== -1 ||
        exchange === '555' ||
        last4 === '1212' ||
        last4 === '1234' ||
        /(\d)\1{3}/.test(last4)
      ) {
        phoneErr.textContent = '* Please enter a valid phone number.';
        valid = false;
      } else {
        phoneErr.textContent = '';
      }

      return valid;
    }

    /* ---------------------------------------------------------------
     * ZIP CODE LOOKUP
     * ------------------------------------------------------------- */
    function zipGetCityState(callback) {
      var zip = document.getElementById('user_zip').value.trim();
      var url = 'https://maps.googleapis.com/maps/api/geocode/json?components=country:US|postal_code:' + zip + '&key=AIzaSyDAc81214Gn8dRazl1W1rRXrAWHhCqsuD0';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status === 'OK' && data.results && data.results[0]) {
            var components = data.results[0].address_components;
            var city = '';
            var state = '';
            components.forEach(function (c) {
              if (c.types[0] === 'administrative_area_level_1') state = c.short_name;
              if (c.types[0] === 'locality') city = c.short_name;
            });
            document.getElementById('lander_city').value = city;
            document.getElementById('lander_state').value = state;
          }
          if (callback) callback();
        })
        .catch(function () {
          // Proceed even if lookup fails
          if (callback) callback();
        });
    }

    /* ---------------------------------------------------------------
     * FORM SUBMISSION (AJAX)
     * ------------------------------------------------------------- */
    function submitForm() {
      var submitBtn = form.querySelector('.lander-submit-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      var formData = new FormData(form);

      fetch(landerFormData.ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.success && json.data && json.data.redirect) {
            window.location.href = json.data.redirect;
          } else {
            // Unmatched or error — still redirect to thank-you with status
            var redirect = (json.data && json.data.redirect) ? json.data.redirect : landerFormData.thankYou + '?status=Error';
            window.location.href = redirect;
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Get Results';
          }
          alert('Something went wrong. Please try again or call us directly.');
        });
    }

  } // end init

})();
